import { render } from "./ProcessedBatch.vue?vue&type=template&id=11035f67&scoped=true"
import script from "./ProcessedBatch.vue?vue&type=script&lang=js"
export * from "./ProcessedBatch.vue?vue&type=script&lang=js"

import "./ProcessedBatch.vue?vue&type=style&index=0&id=11035f67&lang=scss&scoped=true"
import "./ProcessedBatch.vue?vue&type=style&index=1&id=11035f67&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11035f67"]])

export default __exports__